import {
  type GraphPathInfo,
  type LayoutAlgorithm,
  layoutAlgorithms,
} from '@ipfabric/utils';

/**
 * When particular layout algorithm is set for path (so it is not user-defined)
 * and a different algorithm was used at the end, it means a fallback was used.
 */
export const isFallbackLayout = (info?: GraphPathInfo): boolean =>
  info !== undefined &&
  layoutAlgorithms.includes(info.defaultLayout as LayoutAlgorithm) &&
  info.layoutAlgorithm !== info.defaultLayout;
